import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Inject, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/badge/badge';

class FadvBadgeComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        /** Applies Duotone style to badge. */
        this.duotone = false;
        /* Draws a pill-style badge with rounded edges */
        this.pill = false;
        /* Makes the badge pulsate to draw attention */
        this.pulse = false;
        /* When true the badge will appear more circular with less padding */
        this.dot = false;
        this.removed = new EventEmitter();
    }
    handleRemove() {
        this.removed.emit();
    }
}
FadvBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvBadgeComponent, selector: "fadv-badge", inputs: { variant: "variant", duotone: "duotone", pill: "pill", pulse: "pulse", dot: "dot", size: "size", removable: "removable" }, outputs: { removed: "removed" }, host: { listeners: { "sl-remove": "handleRemove()" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "duotone", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "pulse", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "dot", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "size", void 0);
__decorate([
    Forward()
], FadvBadgeComponent.prototype, "removable", void 0);
__decorate([
    Track()
], FadvBadgeComponent.prototype, "removed", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-badge',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { variant: [{
                type: Input
            }], duotone: [{
                type: Input
            }], pill: [{
                type: Input
            }], pulse: [{
                type: Input
            }], dot: [{
                type: Input
            }], size: [{
                type: Input
            }], removable: [{
                type: Input
            }], removed: [{
                type: Output
            }], handleRemove: [{
                type: HostListener,
                args: ['sl-remove']
            }] } });

class FadvBadgeModule {
}
FadvBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeModule, declarations: [FadvBadgeComponent], imports: [FadvCommonModule], exports: [FadvBadgeComponent] });
FadvBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvBadgeComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvBadgeComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvBadgeComponent, FadvBadgeModule };
